module.exports = __webpack_public_path__ + "media/images/team/team5-d6289ceb668163ca50ea07f678793444.jpg";